export const agentKeys = {
  all: ['agent'] as const,
  conversations: () => [...agentKeys.all, 'conversations'] as const,
  messages: (conversationId: string) => [...agentKeys.all, 'conversation', conversationId, 'messages'] as const,
  // Simultaneous providers cache incompatible list shapes under separate namespaces.
  chatwoot: {
    all: ['agent', 'chatwoot'] as const,
    conversations: () => [...agentKeys.chatwoot.all, 'conversations'] as const,
    messages: (conversationId: string) =>
      [...agentKeys.chatwoot.all, 'conversation', conversationId, 'messages'] as const,
  },
};
